



































import { defineComponent } from '@vue/composition-api';
import { TabTypeEnum } from '@/widgets/loan-right/types';

export default defineComponent({
  name: 'TabWithScopedSlot',
  props: {
    tabName: {
      type: Array,
      default: () => ['优先审核通道', '普通申请'],
      required: false,
    },
    showSpeed: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  emits: ['tab-click'],
  setup(props, { emit }) {
    const handleTabClick = (index: TabTypeEnum) => {
      emit('tab-click', index);
    };

    return {
      handleTabClick,
      TabTypeEnum,
    };
  },
});
